import { IOrderProductFactory, OrderProductStatus } from '../../entities/order-product/OrderProduct'
import stripTags from '../../utils/strip-tags/index'

export interface IProductResponse {
  'product_id':         number // 16,
  'product_code':       string // 'MAE',
  'status':             string // 'New',
  'status_code':        string // 'O',
  'item_id':            number // 3541194866,
  'price':              number // 15,
  'subtotal':           number // 15,
  'is_declined':        false,
  'is_canceled':        false,
  'is_labeled':         false,
  'label':              string // '',
  'max_quantity':       number //
  'quantity':           number // 1,
  'product_options':    Record<string, string> // [],
  'logistic_class':     string // '',
  'product_name':       string // 'CUP',
  'short_description':  string // '',
  'image_url':          string // ''
}

export const transformProduct = (product: IProductResponse) : IOrderProductFactory => {
  const status = (
    product.is_canceled
    ? {
      statusCode: OrderProductStatus.CANCELED,
      status: 'Canceled',
    }
    : {
      statusCode: product.status_code,
      status:     product.status,
    }
  )

  return {
    id:         product.product_id,
    code:       product.product_code,
    ...status,
    price:      product.price,
    subtotal:   product.subtotal,
    isDeclined: product.is_declined,
    isCanceled: product.is_canceled,
    isLabeled:  product.is_labeled,
    label:      product.label ? product.label : null,
    quantity:   product.quantity,
    acceptQuantity: product.max_quantity,
    options:    product.product_options,
    imageUrl:   product.image_url ? product.image_url : null,
    logisticClass:    product.logistic_class ? product.logistic_class : null,
    name:             product.product_name,
    shortDescription: stripTags(product.short_description),
    itemId:           product.item_id,
  }
}
